import {memo} from 'react'

import classes from "./DrinkRecipeCard.module.css";

import Modal from "../../UI/Modal";
import RecipeBody from "./Recipe_Body/RecipeBody";
import DrinkActions from "./DrinkActions/DrinkActions";
import RecipeHeader from "./RecipeHeader/RecipeHeader";


// component contains all info about given cocktail and allows user to add cocktail to cart
const DrinkRecipeCard = (props) => {
  

  const cocktail = props.drink;
  
  return (
    <Modal onClose={props.onClose}>
      <div className={classes.drink_recipe_card}>
        <div className={classes.header}>
          <RecipeHeader title={cocktail.title} />
        </div>
        <div className={classes.body}>
          <RecipeBody drink={props.drink} onClose={props.onClose} />
        </div>
        <div className={classes.footer}>
          <DrinkActions cocktail={cocktail} onClose={props.onClose} />
        </div>
      </div>
    </Modal>
  );
};

export default memo(DrinkRecipeCard);
